import React from 'react';
import { useTranslation } from 'react-i18next';

const Location: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-[#0A4A7A] mb-8">{t('location.title')}</h1>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="bg-gray-50 rounded-lg p-6">
            <h2 className="text-2xl font-semibold mb-6 text-[#0A4A7A]">{t('location.address')}</h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-semibold text-[#0A4A7A]">{t('location.address')}</h3>
                <p className="text-gray-700">Gustavsbergs Värdshus<br />Algatan 3, Våning 1<br/>134 40 Gustavsberg<br />Värmdö kommun</p>
              </div>
              <div><h3 className="font-semibold text-[#0A4A7A]">{t('contact.phone')}</h3><p className="text-gray-700">072-334 47 74</p></div>
              <div><h3 className="font-semibold text-[#0A4A7A]">{t('contact.email')}</h3><p className="text-gray-700">info@varmdohorsel.se</p></div>
              <div>
                <h3 className="font-semibold text-[#0A4A7A]">{t('contact.hours')}</h3>
                <div className="text-gray-700">
                  <p>{t('contact.monThu')}: 09:00 - 16:00</p>
                  <p>{t('contact.fri')}: 09:00 - 12:00</p>
                  <p>{t('contact.sat')}: 10:00 - 14:00</p>
                  <p>{t('contact.sun')}: {t('contact.closed')}</p>
                </div>
              </div>
            </div>
            <div className="mt-8">
              <h3 className="font-semibold text-[#0A4A7A] mb-2">{t('location.publicTransport')}</h3>
              <p className="text-gray-700 text-sm">{t('location.publicTransportText')}</p><br/>
              <h3 className="font-semibold text-[#0A4A7A] mb-2">{t('location.parking')}</h3>
              <p className="text-gray-700 text-sm">{t('location.parkingText')}</p>
            </div>
          </div>
          <div>
            <h2 className="text-2xl font-semibold mb-6 text-[#0A4A7A]">{t('location.directions')}</h2>
            <div className="bg-gray-50 rounded-lg h-96 flex items-center justify-center">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2035.8234567890123!2d18.3828891!3d59.3248991!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465f805e2986aaab%3A0x672363344d630ba5!2sGustavsbergs%20V%C3%A4rdshus!5e0!3m2!1ssv!2sse!4v1695902345678!5m2!1ssv!2sse" width="100%" height="100%" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="rounded-lg" title="Värmdö Hörsel location"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Location;
